import { useEffect, useState } from "react";
import { CommonAxiosGet } from "../../CommonUtilities/CommonAxios/CommonAxios";
import { config } from "../../CommonUtilities/CommonUrl/CommonUrls";
import { CommonReactTable } from "../../CommonUtilities/CommonTable/CommonReactTable";
import { CommonPageHeading } from "../../CommonUtilities/CommonHeading/CommonPageHeading";
import Sweetalert from "../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import { AbstractColumns } from "../../CommonUtilities/CommonReactColumn/Commoncolumns";
import { useSelector } from "react-redux";


const createColumn = ({
    header,
    accessor,
    code,
    loginreducer,
    setPapersRowData,
    getPapersDrill2
}) => ({
    Header: header,
    accessor,
    Cell: ({ row }) => {
        const value = row.original[accessor];
        const isRestricted = loginreducer === 7 || loginreducer === 10;

        if (isRestricted) return <span>{value}</span>;

        return (
            <button
                className="btn btn-link text-start"
                onClick={() => {
                    if (value > 0) {
                        setPapersRowData(row?.original);
                        getPapersDrill2(row?.original?.post_id, code, row?.original?.id);
                    } else {
                        Sweetalert("No Data Found", "warning");
                    }
                }}
            >
                {value}
            </button>
        );
    },
    Footer: accessor,
    isClickable: loginreducer !== 7 && loginreducer !== 10,
    FooterFunc: () => {
        if (loginreducer !== 7 && loginreducer !== 10) {
            getPapersDrill2("0", code);
        }
    },
});


const getColumns = (loginreducer, setPapersRowData, getPapersDrill2) => [
    { Header: "S.NO", accessor: (row, index) => index + 1, Footer: "Total" },
    { Header: "Post", accessor: "post_name" },

    createColumn({ header: "Total", accessor: "tot_papers", code: "T", loginreducer, setPapersRowData, getPapersDrill2 }),

    {
        Header: "Gender Wise",
        columns: [
            createColumn({ header: "Male", accessor: "male", code: "M", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "Female", accessor: "female", code: "F", loginreducer, setPapersRowData, getPapersDrill2 }),
        ]
    },

    {
        Header: "Caste Wise",
        columns: [
            createColumn({ header: "OC", accessor: "oc", code: "OC", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "BC-A", accessor: "bc_a", code: "BC-A", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "BC-B", accessor: "bc_b", code: "BC-B", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "BC-C", accessor: "bc_c", code: "BC-C", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "BC-D", accessor: "bc_d", code: "BC-D", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "BC-E", accessor: "bc_e", code: "BC-E", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "SC-GR I", accessor: "sc_gr_i", code: "SC-GR I", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "SC-GR II", accessor: "sc_gr_ii", code: "SC-GR II", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "SC-GR III", accessor: "sc_gr_iii", code: "SC-GR III", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "ST", accessor: "st", code: "ST", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "EWS", accessor: "ews", code: "EWS", loginreducer, setPapersRowData, getPapersDrill2 }),
        ]
    },

    {
        Header: "PH Wise",
        columns: [
            createColumn({ header: "VH", accessor: "vh", code: "VH", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "HI", accessor: "hi", code: "HI", loginreducer, setPapersRowData, getPapersDrill2 }),
            createColumn({ header: "OH", accessor: "oh", code: "OH", loginreducer, setPapersRowData, getPapersDrill2 }),
        ]
    }
];


export default function TETPapersReport() {
    const loginreducer = useSelector(
        (state) => state.reducers.loginreducer.loginDetails.loginData?.role_id
    );

    const [showPapersDrill1Data, setPapersDrill1Data] = useState([]);
    const [showPapersDrill2Data, setPapersDrill2Data] = useState([]);
    const [showPapersRowData, setPapersRowData] = useState();
    const [showDrillCount, setDrillCount] = useState();

    const columns_paper = getColumns(
        loginreducer,
        setPapersRowData,
        getPapersDrill2
    );

    function getPapersDrill1() {
        let Url = config.url.CONTEXT_READ_URL + "post-wise-report";
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true && res?.data?.scode === "01") {
                setPapersDrill1Data(res?.data?.data);
                setDrillCount(0);
            } else {
                setPapersDrill1Data([]);
            }
        });
    }

    function getPapersDrill2(paper, caste) {
        let Url =
            config.url.CONTEXT_READ_URL +
            "post-wise-report/drill?postId=" +
            paper +
            "&caste=" +
            caste;

        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true && res?.data?.scode === "01") {
                setPapersDrill2Data(res?.data?.data);
                setDrillCount(1);
            } else {
                Sweetalert("No Data Found", "warning");
                setPapersDrill2Data([]);
            }
        });
    }

    function isBackFunction() {
        setDrillCount(showDrillCount - 1);
    }

    useEffect(() => {
        getPapersDrill1();
    }, []);

    return (
        <div>
            <CommonPageHeading heading="TET Paper Wise Report" back={false} />

            {showDrillCount === 0 && (
                <>
                    {showPapersDrill1Data?.length > 0 ? (
                        <div className="table-responsive">
                            <CommonReactTable
                                tableid="selected-id"
                                pagination="true"
                                data={showPapersDrill1Data}
                                columns={columns_paper}
                                serachAlign="left"
                                isBack={false}
                                headerName={<>TET Paper Wise Report</>}
                                headColumCount={23}
                                search="true"
                                showFooter="true"
                                filename="Report"
                                paginationCount="All"
                            />
                        </div>
                    ) : (
                        <div className="text-error text-center">
                            *** No Data Found***
                        </div>
                    )}
                </>
            )}

            {showDrillCount === 1 && (
                <>
                    {showPapersDrill2Data?.length > 0 ? (
                        <div className="table-responsive">
                            <CommonReactTable
                                tableid="selected-id"
                                pagination="true"
                                data={showPapersDrill2Data}
                                columns={AbstractColumns}
                                serachAlign="left"
                                isBack={true}
                                isBackFunction={isBackFunction}
                                headerName={
                                    <>
                                        TET Paper Wise Report{" "}
                                        {showPapersRowData?.post_name && (
                                            <span style={{ color: "tomato" }}>
                                                - {showPapersRowData?.post_name}
                                            </span>
                                        )}
                                    </>
                                }
                                headColumCount={16}
                                search="true"
                                filename="Report"
                            />
                        </div>
                    ) : (
                        <div className="text-error text-center">
                            *** No Data Found***
                        </div>
                    )}
                </>
            )}
        </div>
    );
}